import H2 from "../components/H2"
import RequestFundingForLargeProjectForm from "../components/forms/RequestFundingForLargeProjectForm";
import ContactSidebar from "../components/ContactSidebar"

export default function Contact() {
  return (
    <div className="flex flex-wrap mb-20 lg:mb-32">
      <div className="w-full md:w-2/3">
        <H2 title="Request funding for a large project" subtitle="Funding need: €1 million and above" />
        <RequestFundingForLargeProjectForm />
      </div>
      <ContactSidebar />
    </div>
  );
}